export function selectUrlTransition() {
  const urlChangeAll = document.querySelectorAll('.js-selectUrl');

  urlChangeAll.forEach((target) => {
    target.addEventListener('change', () => {
      const uri = new URL(window.location.href);
      const thisProtocol = uri.protocol;
      const thisPort = location.port;
      const thisDomain = uri.hostname;
      const selectUrl = target.value;
      let createUrl;

      if (thisPort) {
        createUrl = thisProtocol + '//' + thisDomain + ':' + thisPort + selectUrl;
      } else {
        createUrl = thisProtocol + '//' + thisDomain + selectUrl;
      }
      window.location.href = createUrl;
    });
  });
}
